$(document).on('turbo:load', function() {
  $(document).on('change', '.scoreboards-sb-specialist-component .specialist-scoreboard-select-js', function() {
    $(this).closest('form')[0].requestSubmit();;
  });
});